module.exports = __webpack_public_path__ + "img/logo.34ab065f.png";